import React, { useState } from 'react';
import cn from 'classnames';
import metrikaGoal from '../../../helpers/metrikaGoal';
import PopupClose from '../Close';

export default function Certification({certData, error, onCloseCallback}) {
  const [certLang, setCertLang] = useState('ru');

  const resultCertData = certData && {
    ru: {previewUrl: certData.PREVIEW_RU, fileUrl: certData.PDF_RU, courseTitle: certData.courseTitle,},
    en: {previewUrl: certData.PREVIEW_EN, fileUrl: certData.PDF_EN, courseTitle: certData.courseTitle,},
  };

  const { previewUrl, fileUrl, courseTitle } = resultCertData[certLang];

  const setRuCertLang = () => setCertLang("ru");
  const setEnCertLang = () => {
    metrikaGoal('sertEN');
    setCertLang("en");
  };

  return (
    <div className="popup-cert-container">
      <div className="popup__close-container close_cert"><PopupClose/></div>
      <div className={cn("popup cert-popup close", {"cert-popup--error": error})}>
        {!error ? (
          <>
            <img className="cert-popup__preview" src={previewUrl} alt="Изображние сертификата" />
            <div className="cert-popup__right-side">
              <div className="cert-popup__title">
                <div className="cert-popup__title-small">Поздравляем! Вы завершили обучение по курсу</div>
                <div className="cert-popup__title-big">&quot;{courseTitle}&quot;</div>
              </div>
              <div className="cert-popup__lang-buttons">
                <button
                  className={cn("cert-popup__lang-button", {"cert-popup__lang-button--active": certLang === "ru"})}
                  type="button"
                  onClick={setRuCertLang}
                >
                  RU
                </button>
                <button
                  className={cn("cert-popup__lang-button", {"cert-popup__lang-button--active": certLang === "en"})}
                  type="button"
                  onClick={setEnCertLang}
                >
                  EN
                </button>
              </div>
              <a href={`${fileUrl}?download=true`} target="_blank" rel="noreferrer" className="btn btn--primary cert-popup__btn">Скачать сертификат</a>
              <div className="cert-popup__social-title">Поделитесь новостью с друзьями</div>
              <div className="cert-popup__socials">
                <a
                  className="cert-popup__social cert-popup__social--fb"
                  href={`https://fb.com/sharer/sharer.php?u=${fileUrl}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>fb.com</span>
                </a>
                <a
                  className="cert-popup__social cert-popup__social--vk"
                  href={`https://vk.com/share.php?url=${fileUrl}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>vk.com</span>
                </a>
                <a
                  className="cert-popup__social cert-popup__social--ok"
                  href={`https://connect.ok.ru/dk?cmd=WidgetSharePreview&st.cmd=WidgetSharePreview&st.shareUrl=${fileUrl}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>ok.ru</span>
                </a>
                <a
                  className="cert-popup__social cert-popup__social--tw"
                  href={`https://twitter.com/intent/tweet?url=${fileUrl}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>ok.ru</span>
                </a>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="cert-popup__warning-title">Ошибка получения данных</div>
            <div className="cert-popup__warning-text">{error}</div>
            <button type="button" className="btn btn--primary" onClick={onCloseCallback}>Закрыть</button>
          </>
        )}
      </div>
    </div>
  );
}